import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ExportConfigurationItem from './ExportConfigurationItem';
import { ObsoleteExportConfiguration } from '../../../types/export/exportConfiguration';

interface ExportItemsProps {
  items: ObsoleteExportConfiguration[];
  selected: Set<string>;
  setSelected: (selected: Set<string>) => void;
  createPath: string;
}

export default function ExportItems({ items, selected, setSelected, createPath }: ExportItemsProps) {
  const navigate = useNavigate();

  const sortedItems = items.sort((a, b) => (a.default ? -1 : 1));

  useEffect(() => {
    if (sortedItems.length && !selected.size) setSelected(new Set([sortedItems[0].id]));
  }, [items]);

  const handleSelect = (item: ObsoleteExportConfiguration) => {
    if (selected.has(item.id)) {
      selected.delete(item.id);
    } else {
      selected.add(item.id);
    }
    setSelected(new Set(selected));
  };

  return (
    <div className='flex flex-wrap gap-4'>
      {items.length ? (
        items.map(item => (
          <ExportConfigurationItem item={item} onClick={() => handleSelect(item)} selected={selected.has(item.id)} />
        ))
      ) : (
        <ExportConfigurationItem
          item={{ name: 'Default', default: true, id: '' }}
          onClick={() => setSelected(new Set())}
          selected={!selected.size}
        />
      )}
      <ExportConfigurationItem item={null} onClick={() => navigate(createPath)} />
    </div>
  );
}
